import { render } from "./OtpVerifyPage.vue?vue&type=template&id=bb5e758a&scoped=true"
import script from "./OtpVerifyPage.vue?vue&type=script&lang=js"
export * from "./OtpVerifyPage.vue?vue&type=script&lang=js"

import "./OtpVerifyPage.vue?vue&type=style&index=0&id=bb5e758a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb5e758a"]])

export default __exports__